module.exports = __webpack_public_path__ + "static/img/9a9df2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/openAccount/images/lhmj.png
// module id = 624
// module chunks = 2